<app-study-material-student [server_user_id]="student_user_id"></app-study-material-student>
